import * as React from "react";
import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DateFormatter from "helper/dateFormartter";

export default function RequestTable(props) {

  const dateFormatter = DateFormatter();
  const rows = props.rows;

  // This function will handle truncating the response message and toggling between the full/short version
  const RenderResponseMessage = ({ message }) => {
    const [showFullMessage, setShowFullMessage] = useState(false);
    const maxLength = 50; // You can change this length based on your need

    const toggleMessage = () => {
      setShowFullMessage(!showFullMessage);
    };

    if (!message) return "-";

    const isLongMessage = message.length > maxLength;
    const displayMessage = showFullMessage ? message : `${message.substring(0, maxLength)}`;

    return (
      <>
        {displayMessage}
        {isLongMessage && (
          <Button size="small" onClick={toggleMessage}>
            {showFullMessage ? "See less" : "See more"}
          </Button>
        )}
      </>
    );
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid black",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>DateTime</TableCell>
            <TableCell>Method</TableCell>
            <TableCell>URL</TableCell>
            {/* <TableCell>JSON</TableCell> */}
            <TableCell>Status Code</TableCell>
            <TableCell>Status Message</TableCell>
            <TableCell>Response Message</TableCell>
            <TableCell>Batch Id</TableCell>
          </TableRow>
        </TableHead>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={12}>
              <Typography textAlign="center" color="lightgray">
                No Data Available
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" width="200px">
                  {row.transactionId}
                </TableCell>
                <TableCell>{row.tran_DateTime}</TableCell>
                <TableCell>{row.method || "-"}</TableCell>
                <TableCell width="200px">{row.url || "-"}</TableCell>
                {/* <TableCell style={{ width: "300px", overflow: "hidden" }}>
                  <textarea
                    value={row.json || "-"}
                    cols={70}
                    rows={2}
                    // readOnly // Makes the textarea read-only
                    style={{
                      border: "none",          // Remove border
                      overflow: "hidden",       // Hide scrollbars
                      resize: "none",           // Prevent resizing
                      backgroundColor: "transparent" // Optional: make background transparent to blend in
                    }}
                  />
                </TableCell> */}
                <TableCell>{row.status_Code || "-"}</TableCell>
                <TableCell>{row.status_message || "-"}</TableCell>
                <TableCell width="700px">
                  <textarea
                    value={row.response_message || "-"}
                    cols={40}
                    rows={2}
                    readOnly // Makes the textarea read-only
                    style={{
                      border: "none",          // Remove border
                      overflow: "hidden",       // Hide scrollbars
                      resize: "none",           // Prevent resizing
                      backgroundColor: "transparent" // Optional: make background transparent to blend in
                    }}
                  />
                </TableCell>
                <TableCell>{row.batch_id || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
